module.exports = __webpack_public_path__ + "img/market_demo.46f88fe4.png";